import api from '../api';
import {toast} from "react-toastify";
import messageTypes from "../../constants/MessagesTypes";
import { addCompanyIdToRequest, getCurrentCompanyId } from '../../utils/companyContext';

export async function getStockMovements(data) {
  const params = addCompanyIdToRequest(data || {}, 'GET');
  
  return api.get(`/api/stock-movement`, {
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
      auth: true
    },
  }).catch((error) => {
    toast.error(messageTypes.ERROR_LOAD);
    return [];
  });
}

export function edit(id, data) {
  // Se for FormData, o companyId já foi adicionado na página
  // Se for objeto JSON, adiciona companyId
  const dataWithCompany = data instanceof FormData 
    ? data 
    : addCompanyIdToRequest(data, 'POST');
  
  return api.post(`/api/stock-movement/edit/${id}`, dataWithCompany, {
    headers: {
      'Content-Type': 'multipart/form-data',
      auth: true
    },
  });
}

export function save(data) {
  // Se for FormData, o companyId já foi adicionado na página
  // Se for objeto JSON, adiciona companyId
  const dataWithCompany = data instanceof FormData 
    ? data 
    : addCompanyIdToRequest(data, 'POST');
  
  return api.post('/api/stock-movement/new', dataWithCompany, {
    headers: {
      'Content-Type': 'multipart/form-data',
      auth: true
    },
  });
}

export async function getStockMovement(id) {
  try {
    const params = addCompanyIdToRequest({}, 'GET');

    const response = await api.get(`/api/stock-movement/${id}/find`, {
      params: params,
      headers: {
        'Content-Type': 'multipart/form-data',
        auth: true
      },
    });

    return response.data.data ? response.data.data : {};

  } catch (err) {
    toast.error(messageTypes.ERROR_LOAD);
    throw err;
  }
}

export function deleteStockMovement(id) {
  // Para DELETE, usamos query params
  const params = addCompanyIdToRequest({}, 'DELETE');
  
  return api.delete(`/api/stock-movement/delete/${id}`, {
    params: params,
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  });
}

export function uploadXmlNFe(formData) {
  // Para FormData, precisamos adicionar companyId ao FormData
  const companyId = getCurrentCompanyId();
  if (companyId) {
    formData.append('companyId', companyId);
  }
  
  return api.post('/api/stock-movement/upload-xml', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      auth: true
    },
  });
}

export function saveFromXml(data) {
  const dataWithCompany = addCompanyIdToRequest(data, 'POST');
  
  return api.post('/api/stock-movement/save-from-xml', dataWithCompany, {
    headers: {
      'Content-Type': 'application/json',
      auth: true
    },
  });
}
